import React from "react";
import _ from "lodash";
import { useOutletContext } from "react-router-dom";
import { useTheme } from "@mui/styles";

import Box from "@mui/material/Box";

import { StyledChatAreaContainer } from "./TicketDetail.styles";
import { useMediaQuery } from "@mui/material";
import { useIntl } from "react-intl";
import UserInfo from "../importList/components/UserInfo";

const sideBarWidth = "300px";

const UserOverview = ({ userIds, getUserList }) => {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();

  const theme = useTheme();
  const computer = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box
      position={"relative"}
      height="100%"
      borderRadius={"8px"}
      overflow={computer ? "auto" : "auto"}
    >
      <Box
        alignItems="stretch"
        flexDirection={computer ? "row" : "column"}
        display="flex"
        width="100%"
        height={computer ? "100%" : "unset"}
      >
        <StyledChatAreaContainer
          style={{
            backgroundColor: "#FAFAFD",
            width: computer ? `calc(100% - ${sideBarWidth})` : "100%",
          }}
        >
          <UserInfo
            selectedUserIds={userIds}
            entityName={entityName}
            getUserList={getUserList}
            isTicketUserInfo={false}
          />
        </StyledChatAreaContainer>
      </Box>
    </Box>
  );
};

export default UserOverview;
